// FX batch 2 — vanilla ports of React Bits, applied sparingly:
//   Magnet          → .cta / .h2-buynow / .h2-arrow (soft pull, /8 strength — source's /2 too loud)
//   ScrollReveal    → homepage .manifesto-body (per-word opacity+blur scrub, 3°→0 tilt)
//   CountUp         → #stageEdition "Nº 001" counts 000→001 on first view
//   ScrollStack lite→ homepage .dyad-steps nodes stack-slide by scroll progress
//                     (ponytail: no Lenis/pinning — full pin-stack only if asked)
//   Grainient       → grain-only overlay on .hero2 (the gradient half isn't wanted:
//                     fold colors are locked; grain = cinematic finish)
// GlareHover is CSS-only (.card-ph/.door-ph/.disc-visual in site.css).
(function () {
  var clamp01 = function (v) { return Math.min(Math.max(v, 0), 1); };

  // ── Tilted-card hover on all CTAs (magnet drift removed — Faiz) ──
  Array.prototype.forEach.call(document.querySelectorAll('.cta, .cta2, .h2-buynow, .h2-arrow, .pv-buynow'), function (el) {
    el.style.transition = 'transform 0.25s ease-out';
    el.addEventListener('mousemove', function (e) {
      var r = el.getBoundingClientRect();
      if (!r.width) return;
      var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
      var rx = ((e.clientY - cy) / (r.height / 2)) * -6;
      var ry = ((e.clientX - cx) / (r.width / 2)) * 6;
      el.style.transform = 'perspective(40rem) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg) scale(1.03)';
    });
    el.addEventListener('mouseleave', function () { el.style.transform = ''; });
  });

  // ── ScrollReveal (manifesto + any .srv-reveal; params via data attrs) ──
  Array.prototype.forEach.call(
    document.querySelectorAll('.home .manifesto-body, .srv-reveal'),
    function (reveal) {
    var baseOp = +(reveal.dataset.baseOpacity || 0.1);
    var baseRot = +(reveal.dataset.baseRot || 3);
    var blur = +(reveal.dataset.blur || 4);
    var parts = reveal.innerHTML.split(/(<[^>]+>|\s+)/);
    reveal.innerHTML = parts.map(function (p) {
      if (!p || /^<|^\s+$/.test(p)) return p;
      return '<span class="srv-word">' + p + '</span>';
    }).join('');
    var words = reveal.querySelectorAll('.srv-word');
    var revealTick = function () {
      var r = reveal.getBoundingClientRect(), vh = innerHeight;
      var p = clamp01((vh - r.top) / (vh * 0.9));
      reveal.style.transform = 'rotate(' + (baseRot * (1 - clamp01(p * 1.4))).toFixed(2) + 'deg)';
      reveal.style.transformOrigin = '0% 50%';
      for (var i = 0; i < words.length; i++) {
        var lp = clamp01(p * (words.length + 6) - i) ;
        words[i].style.opacity = (baseOp + (1 - baseOp) * lp).toFixed(3);
        words[i].style.filter = lp >= 1 ? '' : 'blur(' + (blur * (1 - lp)).toFixed(1) + 'px)';
      }
    };
    addEventListener('scroll', revealTick, { passive: true });
    revealTick();
  });

  // ── CountUp (edition number) ──
  var ed = document.querySelector('#stageEdition strong');
  if (ed && /Nº\s*\d+/.test(ed.textContent)) {
    var target = parseInt(ed.textContent.replace(/\D/g, ''), 10);
    new IntersectionObserver(function (es, io) {
      if (!es[0].isIntersecting) return;
      io.disconnect();
      var t0 = performance.now(), DUR = 1400;
      (function tick(now) {
        var p = clamp01((now - t0) / DUR);
        var e = 1 - Math.pow(1 - p, 3);
        ed.textContent = 'Nº ' + String(Math.round(target * e)).padStart(3, '0');
        if (p < 1) requestAnimationFrame(tick);
      })(t0);
    }, { threshold: 0.6 }).observe(ed);
  }

  // ── ScrollStack lite (dyadic steps) ──
  var steps = document.querySelectorAll('.home .dyad-steps .dyad-node');
  if (steps.length) {
    var stepsWrap = document.querySelector('.home .dyad-steps');
    var stackTick = function () {
      var r = stepsWrap.getBoundingClientRect(), vh = innerHeight;
      var p = clamp01((vh - r.top) / (vh * 0.7));
      for (var i = 0; i < steps.length; i++) {
        var lp = clamp01(p * (steps.length + 1) - i);
        var e = 1 - Math.pow(1 - lp, 3);
        steps[i].style.opacity = e.toFixed(3);
        steps[i].style.transform = 'translateY(' + (48 * (1 - e)).toFixed(1) + 'px) scale(' + (0.92 + 0.08 * e).toFixed(3) + ')';
      }
    };
    addEventListener('scroll', stackTick, { passive: true });
    stackTick();
  }

  // ── Grainient (grain finish on hero2 fold) ──
  var hero = document.querySelector('.hero2');
  if (hero) {
    var g = document.createElement('div');
    g.className = 'mz-grain';
    g.setAttribute('aria-hidden', 'true');
    hero.appendChild(g);
  }
})();
